// extracted by mini-css-extract-plugin
export var active = "Header-module--active--81c45";
export var darkMode = "Header-module--dark-mode--a7212";
export var lightMode = "Header-module--light-mode--264f1";
export var name = "Header-module--name--5715e";
export var nav = "Header-module--nav--5b639";